var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) {
        Object.defineProperty(cooked, "raw", { value: raw });
    }
    else {
        cooked.raw = raw;
    }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function (t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s)
                if (Object.prototype.hasOwnProperty.call(s, p))
                    t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try {
            step(generator.next(value));
        }
        catch (e) {
            reject(e);
        } }
        function rejected(value) { try {
            step(generator["throw"](value));
        }
        catch (e) {
            reject(e);
        } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function () { if (t[0] & 1)
            throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function () { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f)
            throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _)
            try {
                if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done)
                    return t;
                if (y = 0, t)
                    op = [op[0] & 2, t.value];
                switch (op[0]) {
                    case 0:
                    case 1:
                        t = op;
                        break;
                    case 4:
                        _.label++;
                        return { value: op[1], done: false };
                    case 5:
                        _.label++;
                        y = op[1];
                        op = [0];
                        continue;
                    case 7:
                        op = _.ops.pop();
                        _.trys.pop();
                        continue;
                    default:
                        if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                            _ = 0;
                            continue;
                        }
                        if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) {
                            _.label = op[1];
                            break;
                        }
                        if (op[0] === 6 && _.label < t[1]) {
                            _.label = t[1];
                            t = op;
                            break;
                        }
                        if (t && _.label < t[2]) {
                            _.label = t[2];
                            _.ops.push(op);
                            break;
                        }
                        if (t[2])
                            _.ops.pop();
                        _.trys.pop();
                        continue;
                }
                op = body.call(thisArg, _);
            }
            catch (e) {
                op = [6, e];
                y = 0;
            }
            finally {
                f = t = 0;
            }
        if (op[0] & 5)
            throw op[1];
        return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2)
        for (var i = 0, l = from.length, ar; i < l; i++) {
            if (ar || !(i in from)) {
                if (!ar)
                    ar = Array.prototype.slice.call(from, 0, i);
                ar[i] = from[i];
            }
        }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useEffect, useState, useCallback } from 'react';
import styled from 'styled-components';
import AddIcon from '@assets/svg/addIcon.svg';
import './TabletsTab.scss';
import { useAppSelector, useDebounce } from '@/hooks/redux';
import InputSearch from '@/components/InputSearch/InputSearch';
import Modal from './Modals/addTabletModal';
import Input from '@/components/Input/Input';
import { useForm } from 'react-hook-form';
import TabletItem from './TabletItem/tabletItem';
import { useCreateTabletsMutation, useDeleteTabletMutation, useEditTabletsMutation, useGetTabletsWithSearchQuery, } from '@/services/tabletsApi';
import Loader from '@/components/Loader/Loader';
var TabletsTab = function (_a) {
    var restId = _a.restId;
    var _b = useState(''), search = _b[0], setSearch = _b[1];
    var _c = useState(0), show = _c[0], setShow = _c[1];
    var _d = useForm({ defaultValues: { deviceId: '', tableNumber: '' } }), register = _d.register, handleSubmit = _d.handleSubmit, errors = _d.formState.errors, reset = _d.reset;
    var _e = useState(1), page = _e[0], setPage = _e[1];
    var limit = 10;
    // API hooks
    var _f = useGetTabletsWithSearchQuery({
        page: page,
        limit: limit,
        search: search,
        restId: restId,
    }), data = _f.data, isLoading = _f.isLoading, error = _f.error;
    console.log(data, 'datadatadatadatadata');
    var user = useAppSelector(function (state) { return state.authStich.currentUser; });
    var _g = useCreateTabletsMutation(), createTablet = _g[0], _h = _g[1], createError = _h.error, isLoadingCreateTablet = _h.isLoading;
    var _j = useEditTabletsMutation(), editTablet = _j[0], _k = _j[1], editError = _k.error, isLoadingEditTablet = _k.isLoading;
    var _l = useDeleteTabletMutation(), deleteTablet = _l[0], _m = _l[1], deleteError = _m.error, isLoadingDeleteTablet = _m.isLoading;
    var _o = useState(''), _error = _o[0], setError = _o[1];
    // Handle errors
    useEffect(function () {
        if (error || editError || createError || deleteError) {
            console.log(error && (error === null || error === void 0 ? void 0 : error.message), 'error2222222222');
        }
    }, [error, editError, createError, deleteError]);
    // Debounce search
    var debouncedSetSearchText = useDebounce(function (text) {
        setSearch(text);
        setPage(1);
    }, 300);
    // Hide modal
    var hideModal = useCallback(function () {
        setShow(0);
        reset();
    }, [reset]);
    // Submit form
    var onSubmit = function (dataForm) {
        return __awaiter(void 0, void 0, void 0, function () {
            var err_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 5, , 6]);
                        if (!dataForm.tableNumber || Number(dataForm.tableNumber) <= 0) {
                            alert('Номер стола должен быть больше 0');
                            return [2 /*return*/];
                        }
                        if (!(show === 1))
                            return [3 /*break*/, 2];
                        console.log(dataForm);
                        return [4 /*yield*/, createTablet(__assign(__assign({}, dataForm), { tableNummber: dataForm.tableNumber, restaurantId: restId })).unwrap()];
                    case 1:
                        _a.sent();
                        setError('');
                        return [3 /*break*/, 4];
                    case 2:
                        if (!(show === 2))
                            return [3 /*break*/, 4];
                        return [4 /*yield*/, editTablet({ body: { tableNumber: dataForm.tableNumber }, id: dataForm.id })];
                    case 3:
                        _a.sent();
                        _a.label = 4;
                    case 4:
                        // refetchTablets();
                        reset();
                        hideModal();
                        return [3 /*break*/, 6];
                    case 5:
                        err_1 = _a.sent();
                        setError(err_1 === null || err_1 === void 0 ? void 0 : err_1.data.message);
                        return [3 /*break*/, 6];
                    case 6: return [2 /*return*/];
                }
            });
        });
    };
    // Handle delete
    var handleDelete = function (id) {
        return __awaiter(void 0, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, deleteTablet({ tabletId: id })];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    var handletableNumberChange = function (e) {
        var value = e.target.value;
        if (value === '' || /^[1-9]\d*$/.test(value)) {
            e.target.value = value;
        }
        else {
            e.target.value = value.replace(/\D/g, '');
        }
    };
    var handlePreviousPage = function () {
        if (page > 1) {
            setPage(function (prevPage) { return prevPage - 1; });
        }
    };
    var handleNextPage = function () {
        if (page * limit < ((data === null || data === void 0 ? void 0 : data.total) || 0)) {
            setPage(function (prevPage) { return prevPage + 1; });
        }
    };
    return (_jsxs("div", __assign({ className: 'TabletsTab' }, { children: [_jsxs("div", __assign({ style: { padding: '40px', paddingTop: '0px' } }, { children: [_jsx(InputSearch, { setSearch: debouncedSetSearchText }), (user === null || user === void 0 ? void 0 : user.role) !== 'сотрудник' && (_jsx(AddIcon, { onClick: function () {
                            reset({ deviceId: '', tableNumber: '' });
                            setShow(1);
                        }, style: { marginTop: '32px', display: 'flex', alignSelf: 'flex-start', marginBottom: '24px', cursor: 'pointer' } })), (isLoading) ? (_jsx(LoaderContainer, { children: _jsx(Loader, { width: '50px', height: '50px' }) })) : (_jsx(_Fragment, { children: data && data.data && data.data.length ? (__spreadArray([], data.data, true).map(function (item, index, arr) {
                            return (_jsx(TabletItem, { onClick: function () {
                                    setShow(2);
                                    reset({ deviceId: item.deviceId, tableNumber: item.tableNumber, id: item.id });
                                }, id: item.deviceId, table: item.tableNumber, onDelete: function () { return handleDelete(item.id); }, isLast: index === arr.length - 1, isFirst: index === 0, isLoading: isLoadingDeleteTablet }, item.id));
                        })) : (_jsxs(TabletsList, { children: [_jsx(EmptyList, { children: "\u0421\u043F\u0438\u0441\u043E\u043A \u043F\u0443\u0441\u0442" }), _jsx("span", __assign({ style: { fontFamily: 'Montserrat Regular', fontWeight: 400, fontSize: '16px' } }, { children: "\u0417\u0434\u0435\u0441\u044C \u043E\u0442\u043E\u0431\u0440\u0430\u0437\u0438\u0442\u0441\u044F \u0441\u043F\u0438\u0441\u043E\u043A \u043F\u043B\u0430\u043D\u0448\u0435\u0442\u043E\u0432" }))] })) }))] })), _jsxs(PaginationContainer, { children: [_jsx(ChangePageButton, __assign({ onClick: handlePreviousPage, disabled: page === 1 }, { children: _jsx("svg", __assign({ viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, { children: _jsx("path", { d: "M15 18L9 12L15 6", stroke: "currentColor", strokeWidth: "2", strokeLinecap: "round", strokeLinejoin: "round" }) })) })), _jsxs("span", { children: ["\u0421\u0442\u0440\u0430\u043D\u0438\u0446\u0430 ", page] }), _jsx(ChangePageButton, __assign({ onClick: handleNextPage, disabled: page * limit >= ((data === null || data === void 0 ? void 0 : data.total) || 0) }, { children: _jsx("svg", __assign({ viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, { children: _jsx("path", { d: "M9 6L15 12L9 18", stroke: "currentColor", strokeWidth: "2", strokeLinecap: "round", strokeLinejoin: "round" }) })) }))] }), _jsxs(Modal, __assign({ show: show, handleClose: hideModal }, { children: [_error && _jsx("p", __assign({ style: { color: 'red' } }, { children: _error })), _jsx(ModalContent, { children: _jsxs("form", __assign({ onSubmit: handleSubmit(onSubmit), style: {
                                display: 'flex',
                                flexDirection: 'column',
                                height: '100%',
                            } }, { children: [_jsx("div", __assign({ style: {
                                        background: '#FFFFFF',
                                        padding: '24px',
                                        borderTopLeftRadius: '8px',
                                        borderTopRightRadius: '8px',
                                        borderTop: '1px solid #E3E3E3',
                                        borderLeft: '1px solid #E3E3E3',
                                        borderRight: '1px solid #E3E3E3'
                                    } }, { children: _jsx("span", __assign({ style: {
                                            fontFamily: 'Montserrat Regular',
                                            fontWeight: 600,
                                            fontSize: '16px',
                                            textAlign: 'left',
                                            display: 'block'
                                        } }, { children: "\u041E\u0441\u043D\u043E\u0432\u043D\u0430\u044F \u0438\u043D\u0444\u043E\u0440\u043C\u0430\u0446\u0438\u044F" })) })), _jsxs("div", __assign({ style: {
                                        background: '#FFFFFF',
                                        padding: '24px',
                                        borderBottomRightRadius: '8px',
                                        borderBottomLeftRadius: '8px',
                                        border: '1px solid #E3E3E3',
                                    } }, { children: [_jsx(HeaderText, { children: "ID \u0443\u0441\u0442\u0440\u043E\u0439\u0441\u0442\u0432\u0430" }), _jsx(Input, { error: !!errors.deviceId, register: __assign({}, register('deviceId', { required: true })), disabled: show === 2, placeholder: '\u0412\u0432\u0435\u0434\u0438\u0442\u0435 ID' }), _jsx("div", { style: { height: '24px' } }), _jsx(HeaderText, { children: "\u041D\u043E\u043C\u0435\u0440 \u0441\u0442\u043E\u043B\u0430" }), _jsx(Input, { inputType: 'number', placeholder: '\u0412\u0432\u0435\u0434\u0438\u0442\u0435 \u043D\u043E\u043C\u0435\u0440', onChange: handletableNumberChange, error: !!errors.tableNumber, register: __assign({}, register('tableNumber', { required: true })) })] })), _jsxs(ButtonContainer, { children: [!(isLoadingCreateTablet || isLoadingEditTablet) ? (_jsx(Button, __assign({ type: 'submit' }, { children: _jsx("span", __assign({ style: {
                                                    fontFamily: 'Montserrat Regular',
                                                    fontWeight: 500,
                                                    fontSize: '16px',
                                                    color: 'white',
                                                } }, { children: show === 1 ? 'Создать' : "Сохранить изменения" })) }))) : (_jsx(Button, { children: _jsx(Loader, { width: '20px', height: '20px' }) })), _jsx(Button, __assign({ type: 'button', style: { background: 'none' }, onClick: hideModal }, { children: _jsx("span", __assign({ style: {
                                                    cursor: 'pointer',
                                                    fontFamily: 'Montserrat Regular',
                                                    fontWeight: 600,
                                                    fontSize: '16px',
                                                    color: '#000000',
                                                    marginLeft: '2vw',
                                                } }, { children: "\u041E\u0442\u043C\u0435\u043D\u0438\u0442\u044C" })) }))] })] })) })] }))] })));
};
var PaginationContainer = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: flex;\n  margin-top: 20px;\n  font-family: 'Montserrat Regular';\n  font-weight: 400;\n  font-size: 16px;\n  justify-content: center;\n  align-items: center;\n"], ["\n  display: flex;\n  margin-top: 20px;\n  font-family: 'Montserrat Regular';\n  font-weight: 400;\n  font-size: 16px;\n  justify-content: center;\n  align-items: center;\n"])));
var ChangePageButton = styled.button(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  background-color: #E621D3;\n  color: #fff;\n  border: none;\n  width: 40px;\n  height: 40px;\n  border-radius: 50%;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  cursor: pointer;\n  margin: 0 10px;\n  transition: background-color 0.3s;\n\n  &:disabled {\n    background-color: #e0e0e0;\n    cursor: not-allowed;\n  }\n\n  &:hover:not(:disabled) {\n    background-color: #d11bbf;\n  }\n\n  svg {\n    width: 20px;\n    height: 20px;\n  }\n"], ["\n  background-color: #E621D3;\n  color: #fff;\n  border: none;\n  width: 40px;\n  height: 40px;\n  border-radius: 50%;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  cursor: pointer;\n  margin: 0 10px;\n  transition: background-color 0.3s;\n\n  &:disabled {\n    background-color: #e0e0e0;\n    cursor: not-allowed;\n  }\n\n  &:hover:not(:disabled) {\n    background-color: #d11bbf;\n  }\n\n  svg {\n    width: 20px;\n    height: 20px;\n  }\n"])));
var PageHeader = styled.div(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    background: #fff;\n    width: 100%;\n    padding-top: 43px;\n    padding-left: 40px;\n    padding-bottom: 27px;\n"], ["\n    background: #fff;\n    width: 100%;\n    padding-top: 43px;\n    padding-left: 40px;\n    padding-bottom: 27px;\n"])));
var TabletsList = styled.div(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n"], ["\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n"])));
var ModalContent = styled.div(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n    display: flex;\n    flex-direction: column;\n    height: 100%;\n    word-wrap: break-word;\n    word-break: break-word;\n    overflow-wrap: break-word;\n"], ["\n    display: flex;\n    flex-direction: column;\n    height: 100%;\n    word-wrap: break-word;\n    word-break: break-word;\n    overflow-wrap: break-word;\n"])));
var ButtonContainer = styled.div(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n    margin-top: auto;\n    display: flex;\n    flex-direction: row;\n"], ["\n    margin-top: auto;\n    display: flex;\n    flex-direction: row;\n"])));
var Button = styled.button(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n    padding: 15px;\n    width: fit-content;\n    border-radius: 30px;\n    background: #E621D3;\n    border: none;\n    cursor: pointer;\n    white-space: nowrap;\n\n    @media (max-width: 768px) {\n        width: 100%;\n        white-space: normal;\n    }\n"], ["\n    padding: 15px;\n    width: fit-content;\n    border-radius: 30px;\n    background: #E621D3;\n    border: none;\n    cursor: pointer;\n    white-space: nowrap;\n\n    @media (max-width: 768px) {\n        width: 100%;\n        white-space: normal;\n    }\n"])));
var HeaderText = styled.span(templateObject_8 || (templateObject_8 = __makeTemplateObject(["\n    font-family: 'Montserrat Regular';\n    font-weight: 400;\n    font-size: 14px;\n    text-align: left;\n    color: #898989;\n    display: block;\n    margin-bottom: 8px;\n"], ["\n    font-family: 'Montserrat Regular';\n    font-weight: 400;\n    font-size: 14px;\n    text-align: left;\n    color: #898989;\n    display: block;\n    margin-bottom: 8px;\n"])));
var EmptyList = styled.span(templateObject_9 || (templateObject_9 = __makeTemplateObject(["\n    font-family: 'Montserrat Regular';\n    font-weight: 500;\n    font-size: 24px;\n    text-align: center;\n    margin: 20px 0;\n"], ["\n    font-family: 'Montserrat Regular';\n    font-weight: 500;\n    font-size: 24px;\n    text-align: center;\n    margin: 20px 0;\n"])));
var LoaderContainer = styled.div(templateObject_10 || (templateObject_10 = __makeTemplateObject(["\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    height: 100%;\n"], ["\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    height: 100%;\n"])));
export default TabletsTab;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9, templateObject_10;
